var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.4,
    height: 33.4,
    viewBox: "0 0 33.4 33.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 33.4,
    height: 33.4,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M16.7,0A16.7,16.7,0,1,0,33.4,16.7,16.719,16.719,0,0,0,16.7,0M11.047,18.484v6.754a.779.779,0,0,1-1.558,0V18.484a1.945,1.945,0,0,1,0-3.567V8.163a.779.779,0,1,1,1.558,0v6.754a1.945,1.945,0,0,1,0,3.567m6.432-4.452V25.238a.779.779,0,0,1-1.558,0V14.032a1.945,1.945,0,0,1,0-3.567v-2.3a.779.779,0,1,1,1.558,0v2.3a1.945,1.945,0,0,1,0,3.567m6.432,6.678v4.528a.779.779,0,0,1-1.558,0V20.709a1.945,1.945,0,0,1,0-3.567V8.163a.779.779,0,1,1,1.558,0v8.98a1.945,1.945,0,0,1,0,3.567",
    transform: "translate(0 0)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.2197814a49893ccadb2816575146238e.svg";
export { ForwardRef as ReactComponent };